import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  SearchInput,
  DateInput,
  NumberInput,
  FilterButton,
  TopToolbar,
} from 'react-admin';

const userFilters = [
  <SearchInput source="search" alwaysOn placeholder="Search username" />,
  <DateInput source="date_from" label="From Date" />,
  <DateInput source="date_to" label="To Date" />,
  <NumberInput source="min_volume" label="Min Volume ($)" />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
  </TopToolbar>
);

export const UserStatsList = () => (
  <List
    filters={userFilters}
    actions={<ListActions />}
    perPage={50}
    sort={{ field: 'total_volume_usd', order: 'DESC' }}
  >
    <Datagrid>
      <TextField source="user_id" label="ID" />
      <TextField source="username" />
      <TextField source="first_name" />
      <NumberField source="total_bets" />
      <NumberField
        source="total_volume_usd"
        options={{ style: 'currency', currency: 'USD' }}
        label="Volume"
      />
      <NumberField
        source="avg_bet_usd"
        options={{ style: 'currency', currency: 'USD' }}
        label="Avg Bet"
      />
      <NumberField source="wins" />
      <NumberField source="losses" />
      <NumberField
        source="win_rate"
        options={{ style: 'percent', minimumFractionDigits: 2 }}
      />
      <DateField source="last_activity" showTime />
    </Datagrid>
  </List>
);
